(function() {
  "use strict";

  angular.module("app").directive("cccDomainYearPicker", cccDomainYearPicker);

  function cccDomainYearPicker() {
    return {
      restrict: "EA",
      scope: false,
      controller: "DomainYearPickerController"
    };
  }
})();
